import * as tslib_1 from "tslib";
import { OnDestroy, OnInit, } from '@angular/core';
import { FormBuilder, FormControl, Validators, } from '@angular/forms';
import { AppStateFacade, Setting, } from '@app-state';
import { UiModalComponent } from '@components/ui-modal/ui-modal.component';
import { FeatureFlag, RobotTypeAttended, UserType, } from '@models';
import { TranslateService } from '@ngx-translate/core';
import { ProvisionRobotComponent } from '@pages/users/components/provision-robot/provision-robot.component';
import { AuthService, ModalService, RoleService, SignalRService, UserService, } from '@services';
import { DEFAULT_NOTIFICATION_SETTINGS } from '@services/user.service';
import UiValidators, { UI_EMAIL_DOMAIN_MAX_LENGTH, UI_NAME_MAX_LENGTH, UI_PASSWORD_MAX_LENGTH, UI_USERNAME_MAX_LENGTH, } from '@validators';
import cloneDeep from 'lodash-es/cloneDeep';
import { BehaviorSubject, iif, of, Subject, } from 'rxjs';
import { finalize, map, switchMap, takeUntil, } from 'rxjs/operators';
var UserModalComponent = /** @class */ (function (_super) {
    tslib_1.__extends(UserModalComponent, _super);
    function UserModalComponent() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.loading$ = new BehaviorSubject(false);
        _this.selectedOrganizations = [];
        _this.disallowEmailChange = false;
        _this.disallowPasswordChange = false;
        _this.UserType = UserType;
        _this._appState = _this._injector.get(AppStateFacade);
        _this._authService = _this._injector.get(AuthService);
        _this._userService = _this._injector.get(UserService);
        _this._modalService = _this._injector.get(ModalService);
        _this._translateService = _this._injector.get(TranslateService);
        _this._signalRService = _this._injector.get(SignalRService);
        _this._roleService = _this._injector.get(RoleService);
        _this._destroyed$ = new Subject();
        _this.roleSearchFactory = function () {
            var args = [];
            for (var _i = 0; _i < arguments.length; _i++) {
                args[_i] = arguments[_i];
            }
            return _this._appState.user.permissions
                .isGranted('Roles.View')
                .pipe(switchMap(function (result) { return result ?
                _this._roleService.suggest.apply(null, args) :
                of(_this.form.get('rolesList').value); }));
        };
        return _this;
    }
    Object.defineProperty(UserModalComponent.prototype, "isCurrentUser", {
        get: function () {
            return this._appState.user.value.id === this.context.data.id;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserModalComponent.prototype, "isRobotProvisionAvailable", {
        get: function () {
            return this.context.data.type !== UserType.Robot &&
                this._appState.settings.get(Setting.isModernFolderSystemEnabled);
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(UserModalComponent.prototype, "provisionRobot", {
        set: function (value) {
            if (!value) {
                this.form.removeControl('robotProvision');
                return;
            }
            this.form.addControl('robotProvision', value.form);
        },
        enumerable: true,
        configurable: true
    });
    UserModalComponent.prototype.ngOnInit = function () {
        var _a;
        var _this = this;
        if (this.context.isNewEntry) {
            this.context.data.type = this.context.additionalData.type;
        }
        this.isRobotSwitcherEnabled$ = iif(function () { return _this.context.data.mayHaveRobotSession; }, this._appState.user.permissions.isGranted('Robots.Delete'), this._appState.user.permissions.isGranted('Robots.Create'));
        this.isRobotEditable$ = iif(function () { return _this.context.data.mayHaveRobotSession; }, this._appState.user.permissions.isGranted('Robots.Edit'), this._appState.user.permissions.isGranted('Robots.Create'));
        var editTitle = (_a = {},
            _a[UserType.DirectoryGroup] = 'user_modal_title_edit_group',
            _a[UserType.DirectoryUser] = 'user_modal_title_edit_directory_user',
            _a[UserType.Robot] = 'user_modal_title_edit_robot',
            _a[UserType.User] = 'user_modal_title_edit',
            _a);
        this.title = this.context.isNewEntry
            ? 'users_grid_action_add'
            : editTitle[this.context.data.type] || 'user_modal_title_edit';
        var fb = this._injector.get(FormBuilder);
        this.isDomainVisible = this._appState.settings.get(Setting.isWindowsAuthEnabled) &&
            !this._appState.settings.isFeatureEnabled(FeatureFlag.DirectoryService);
        this.isWindowsAuthenticationEnabled = this._appState.settings.get(Setting.isWindowsAuthEnabled);
        this.passwordComplexity = this._appState.settings.passwordComplexity;
        this.context.data.rolesList = this.context.data.rolesList || [];
        this.context.data.organizationUnits = this.context.data.organizationUnits || [];
        if (this.context.data.licenseType ||
            this.context.data.isExternalLicensed) {
            this.context.data.robotProvision = this.context.data.robotProvision || { type: null };
            Object.assign(this.context.data.robotProvision, {
                type: this.context.data.licenseType,
                isExternalLicensed: this.context.data.isExternalLicensed,
            });
        }
        this.disallowEmailChange = !this._appState.authConfig.value.cloud.allowSelfEmailUpdate;
        this.disallowPasswordChange = !this._appState.authConfig.value.cloud.allowPasswordChange;
        var userName = [
            this.context.data.userName,
            Validators.compose([
                Validators.required,
                Validators.maxLength(UI_USERNAME_MAX_LENGTH),
            ]),
        ];
        var name = [
            this.context.data.name,
            Validators.compose([
                Validators.maxLength(UI_NAME_MAX_LENGTH),
            ]),
        ];
        var surname = [
            this.context.data.surname,
            Validators.compose([
                Validators.maxLength(UI_NAME_MAX_LENGTH),
            ]),
        ];
        var emailAddress = [
            this.context.data.emailAddress,
            Validators.compose([
                Validators.maxLength(UI_EMAIL_DOMAIN_MAX_LENGTH),
                UiValidators.email(true),
            ]),
        ];
        var password = [
            this.context.data.password,
            Validators.compose([
                Validators.maxLength(UI_PASSWORD_MAX_LENGTH),
                UiValidators.complexity(this.passwordComplexity, false),
            ]),
        ];
        var bypassBasicAuthRestriction = [
            this.context.data.bypassBasicAuthRestriction,
        ];
        var confirmPassword = [''];
        var rolesList = [this.context.data.rolesList.map(this._roleToSuggest)];
        var organizationUnits = [this.context.data.organizationUnits];
        if (this.context.data.type === UserType.User) {
            this.form = fb.group(tslib_1.__assign({ userName: userName,
                name: name,
                surname: surname,
                emailAddress: emailAddress,
                password: password,
                confirmPassword: confirmPassword,
                rolesList: rolesList,
                organizationUnits: organizationUnits }, (this.isBasicAuthRestricted ? { bypassBasicAuthRestriction: bypassBasicAuthRestriction } : {}), { 'mayHaveUserSession': [{
                        value: this.context.data.mayHaveUserSession != null
                            ? this.context.data.mayHaveUserSession
                            : true,
                        disabled: this.isCurrentUser,
                    }] }), { validator: UiValidators.confirmPassword('password', 'confirmPassword') });
        }
        else {
            this.form = fb.group({
                rolesList: rolesList,
                organizationUnits: organizationUnits,
                'mayHaveUserSession': [{
                        value: this.context.data.mayHaveUserSession,
                        disabled: this.isCurrentUser,
                    }],
            });
        }
        if (this.isRobotProvisionAvailable) {
            this.form.addControl('mayHaveRobotSession', new FormControl(this.context.data.mayHaveRobotSession || false));
        }
        if (this.context.isNewEntry) {
            this.context.data.rolesList = [];
            this.context.data.organizationUnits = [];
        }
        this._appState.user.permissions.isGranted('Users.Edit')
            .pipe(map(function (hasUserEdit) { return hasUserEdit || _this.context.isNewEntry; }), takeUntil(this._destroyed$)).subscribe(function (hasUserEdit) {
            Object.keys(_this.form.controls)
                .filter(function (key) { return !['robotProvision', 'mayHaveRobotSession'].includes(key); })
                .forEach(function (key) { return _this.form.get([key])[hasUserEdit ? 'enable' : 'disable'](); });
        });
    };
    UserModalComponent.prototype.ngOnDestroy = function () {
        this._destroyed$.next();
        this._destroyed$.complete();
    };
    UserModalComponent.prototype.onSubmit = function () {
        var _this = this;
        if (!this.form.valid ||
            this.loading$.value) {
            return;
        }
        var passwordControl = this.form.get('password');
        if (this.isCurrentUser && passwordControl && passwordControl.value) {
            this._modalService.onConfirm(null, function () {
                _this._submit();
            }, function () { }, this._translateService.instant('user_modal_password_warning'));
        }
        else {
            this._submit();
        }
    };
    Object.defineProperty(UserModalComponent.prototype, "isBasicAuthRestricted", {
        get: function () {
            return this._appState.settings.isFeatureEnabled(FeatureFlag.RestrictBasicAuth);
        },
        enumerable: true,
        configurable: true
    });
    UserModalComponent.prototype._roleToSuggest = function (role) {
        return {
            id: role,
            text: role,
        };
    };
    UserModalComponent.prototype._submit = function () {
        return tslib_1.__awaiter(this, void 0, void 0, function () {
            var payload, watchedGroups, shouldUserLogout, updateUser$;
            var _this = this;
            return tslib_1.__generator(this, function (_a) {
                this.loading$.next(true);
                payload = cloneDeep(this.context.data);
                Object.assign(payload, cloneDeep(this.form.value));
                payload.rolesList = this.form.get('rolesList')
                    .value.map(function (item) { return item.text; });
                payload.notificationSettings = Object.assign(cloneDeep(DEFAULT_NOTIFICATION_SETTINGS), payload.notificationSettings);
                if (payload.robotProvision &&
                    ![RobotTypeAttended.Development, RobotTypeAttended.StudioX].includes(payload.robotProvision.type)) {
                    payload.robotProvision.isExternalLicensed = false;
                }
                if (this.context.isNewEntry) {
                    // FIXME: implement this in a better way
                    if (this.isRobotProvisionAvailable && payload.robotProvision) {
                        payload.licenseType = payload.robotProvision.type;
                        payload.isExternalLicensed = payload.robotProvision.isExternalLicensed;
                        delete payload.robotProvision.type;
                        delete payload.robotProvision.isExternalLicensed;
                    }
                    return [2 /*return*/, this._userService.add(payload)
                            .pipe(finalize(function () { return _this.loading$.next(false); }))
                            .subscribe(function () {
                            _this._dialogRef.close({
                                type: 1 /* Add */,
                            });
                        })];
                }
                if (this.isRobotProvisionAvailable) {
                    payload.licenseType = payload.robotProvision && payload.robotProvision.type;
                    payload.isExternalLicensed = payload.robotProvision && payload.robotProvision.isExternalLicensed;
                    if (payload.robotProvision) {
                        delete payload.robotProvision.type;
                        delete payload.robotProvision.isExternalLicensed;
                    }
                }
                if (this.context.data.type === UserType.Robot) {
                    delete payload.robotProvision;
                }
                watchedGroups = this._signalRService.watched;
                shouldUserLogout = this.isCurrentUser && this.context.data.password;
                // when the password for the current user is updated, a ping signaling the current permissions were changed is received
                // because the user is logged out. The signal would trigger a getCurrentPermissions that would fail with 401 Unauthorized.
                if (shouldUserLogout) {
                    this._signalRService.disconnect();
                }
                if (this.isCurrentUser &&
                    this.disallowEmailChange) {
                    delete payload['emailAddress'];
                }
                if (this.disallowPasswordChange) {
                    delete payload['password'];
                }
                if (this.isCurrentUser) {
                    updateUser$ = this._appState.user.update(payload);
                }
                else {
                    updateUser$ = this._userService.update(this.context.data.id, payload);
                }
                return [2 /*return*/, updateUser$
                        .pipe(finalize(function () { return _this.loading$.next(false); }))
                        .subscribe(function () {
                        delete payload.password;
                        _this._dialogRef.close({
                            type: 2 /* Update */,
                            data: payload,
                        });
                        if (shouldUserLogout) {
                            _this._authService.logout();
                        }
                    }, function () {
                        if (shouldUserLogout) {
                            _this._signalRService.watched = watchedGroups;
                            _this._signalRService.connect();
                        }
                    })];
            });
        });
    };
    return UserModalComponent;
}(UiModalComponent));
export { UserModalComponent };
